import { BatteryChemistry, type UserPreferences } from '@brt/shared-types'
import type { AppStore } from '../useAppStore.ts'

export interface PreferencesSlice {
  preferences: UserPreferences
  updatePreference: <K extends keyof UserPreferences>(key: K, value: UserPreferences[K]) => void
}

const DEFAULT_PREFERENCES: UserPreferences = {
  defaultChemistry: BatteryChemistry.LI_FEPO4,
  defaultVoltage: 12.8,
  defaultLoadPreset: null,
  locale: 'en-US',
  temperatureUnit: 'CELSIUS',
  dischargeCurveResolution: 100,
  showAdvancedModeDefault: false,
  numberFormat: 'system',
  showSecondsAlways: false,
  defaultEfficiency: 0.93,
  defaultReserveMargin: 0.0,
  autoSaveProfiles: true,
  historyLimit: 50,
  exportFormat: 'pdf',
  textSize: 'normal',
  contrastMode: 'normal',
}

type Set = (fn: (state: AppStore) => Partial<AppStore>) => void

export function createPreferencesSlice(set: Set): PreferencesSlice {
  return {
    preferences: { ...DEFAULT_PREFERENCES },

    updatePreference: (key, value) =>
      set((state) => ({
        preferences: { ...state.preferences, [key]: value },
      })),
  }
}

export { DEFAULT_PREFERENCES }
